import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { CreateSetCardColorCommand } from '../../../api/commands/factory/createCardColor';
import { StorymapState } from '../../types';
import { getCardById } from '../../use';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetCardColor extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SetCardColor';

    public constructor(public cardId: string, public color: number) {
        super(SetCardColor.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetCardColor): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await CreateSetCardColorCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: SetCardColor): void => {
    const card = getCardById(action.cardId);
    if (!card) {
        return;
    }

    card.color = action.color;
};

//@ts-ignore
registerMiddleware(SetCardColor.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetCardColor.ACTION_TYPE, reducer);
